import React from "react";
import "./WhySection.css";
import { ImCheckmark } from "react-icons/im";

const Why = ({ title, subtitle, blocks ,end}) => {
    return (
        <div className="why-section">
            <h2 className="why-title">{title}</h2>
            {subtitle && (
                <p className="why-subtitle">{subtitle}</p>
            )}

            <div className="why-card-content">
                {blocks.map((block, i) => (
                    <div key={i} className="why-card">
                        {block.subtitle && (
                            <h3 className="why-card-title">{block.subtitle}</h3>
                        )}
                        <ul className="why-list">
                            {block.items.map((item, idx) => {
                                const Icon = item.icon || ImCheckmark;

                                return (
                                    <li key={idx} className="why-item">
                                        <div className="why-icon">
                                            {typeof Icon === "string" ? Icon : <Icon />}
                                        </div>
                                        <div className='why-item-text'>
                                            {item.title && (
                                                <div className="why-item-title">{item.title}</div>
                                            )}
                                            {item.text && (
                                                <div className="why-item-description">{item.text}</div>
                                            )}
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>

                    </div>
                ))}
            </div>

            {end && (
                <p>{end}</p>
            )}

        </div>
    );
};

export default Why;
